'use strict';

const PRICING_MAX_BUCKET = 50;

function getCpmDollarBucket(cpm) {
    return Math.min(Math.floor(cpm), PRICING_MAX_BUCKET);
}

module.exports = {
    PRICING_MAX_BUCKET,
    getCpmDollarBucket: getCpmDollarBucket,
};
